import * as Sentry from "@sentry/react"
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuPortal,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"
import { ChevronsUpDownIcon, Globe, LogOutIcon, Settings } from "lucide-react"
import { clearSession } from "@/api/client.ts"
import { useNavigate } from "@tanstack/react-router"
import { authApi } from "@/api/auth.api.ts"
import { logOut } from "@/lib/firebase-auth.ts"
import { useUser } from "@/contexts/UserContext.tsx"
import { useTranslation } from "react-i18next"

export function NavUser() {
  const { user, profilePicture, isLoading, locale, onChangeLocale } = useUser()
  const { t } = useTranslation()
  const navigate = useNavigate()

  // const user = data?.result?.user
  const onClickLogout = async () => {
    await authApi.logout()
    await logOut()
    clearSession()
    Sentry.setUser(null)
    window.location.replace("/login")
  }

  if (!user && isLoading) {
    return (
      <>
        <Avatar>
          <AvatarFallback />
        </Avatar>
        <ChevronsUpDownIcon className="ms-auto size-4" />
      </>
    )
  }

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger
            render={
              <SidebarMenuButton size="lg" className="aria-expanded:bg-muted" />
            }
          >
            <Avatar>
              <AvatarImage src={profilePicture} alt={user?.name} />
              <AvatarFallback>{`${user?.name[0]}${user?.surname[0]}`}</AvatarFallback>
            </Avatar>
            <ChevronsUpDownIcon className="ms-auto size-4" />
          </DropdownMenuTrigger>
          <DropdownMenuContent
            dir={locale === "ar" ? "rtl" : "ltr"}
            className="w-fit"
            side="bottom"
            align="end"
            sideOffset={4}
          >
            <DropdownMenuGroup>
              <DropdownMenuLabel className="p-0 font-normal">
                <div className="flex items-center gap-2 px-1 py-1.5 text-start text-sm">
                  <Avatar>
                    <AvatarImage src={profilePicture} alt={user?.name} />
                    <AvatarFallback>{`${user?.name[0]}${user?.surname[0]}`}</AvatarFallback>
                  </Avatar>
                  <div className="grid flex-1 text-start text-sm leading-tight">
                    <span className="truncate font-medium">
                      {user?.name} {user?.surname}
                    </span>
                    <span className="truncate text-xs">
                      {user?.emailAddress}
                    </span>
                  </div>
                </div>
              </DropdownMenuLabel>
            </DropdownMenuGroup>
            <DropdownMenuSeparator />
            <DropdownMenuGroup>
              <DropdownMenuSub>
                <DropdownMenuSubTrigger>
                  <Globe />
                  {t("navbar.langSwitch")}
                </DropdownMenuSubTrigger>
                <DropdownMenuPortal>
                  <DropdownMenuSubContent>
                    <DropdownMenuGroup>
                      <DropdownMenuLabel>{t("navbar.lang")}</DropdownMenuLabel>
                      <DropdownMenuRadioGroup
                        value={locale}
                        onValueChange={async (lang: string) => {
                          await onChangeLocale(lang)
                        }}
                      >
                        <DropdownMenuRadioItem value="en">
                          🇬🇧 English
                        </DropdownMenuRadioItem>
                        <DropdownMenuRadioItem value="ar">
                          🇪🇬 العربية
                        </DropdownMenuRadioItem>
                      </DropdownMenuRadioGroup>
                    </DropdownMenuGroup>
                  </DropdownMenuSubContent>
                </DropdownMenuPortal>
              </DropdownMenuSub>
            </DropdownMenuGroup>
            {/*<DropdownMenuSeparator />*/}
            {/*<DropdownMenuGroup>*/}
            {/*  <DropdownMenuItem*/}
            {/*    onClick={async () => {*/}
            {/*      await navigate({ to: "/account/settings" })*/}
            {/*    }}*/}
            {/*  >*/}
            {/*    <Settings />*/}
            {/*    Account Settings*/}
            {/*  </DropdownMenuItem>*/}
            {/*</DropdownMenuGroup>*/}
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={onClickLogout}>
              <LogOutIcon />
              {t("navbar.logout")}
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
